import { IPropertyEditable } from "../../../../base/domain/system/edit";
import {
  IPrintBehavior,
  IFreeInputBehavior,
  IImageStyle,
  IObjectsControllable,
  ILinkedPageObjectSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IImageAreaObject } from "../objects";
import { IPrintBehaviorPropertyEditable, IFreeInputBehaviorPropertyEditable } from "../properties";
import { AbstractClaioMediaDrawableObjectEditor } from "./AbstractClaioMediaDrawableObjectEditor";

export class ImageAreaObjectEditor extends AbstractClaioMediaDrawableObjectEditor<IImageAreaObject> implements IPrintBehaviorPropertyEditable, IFreeInputBehaviorPropertyEditable {
  constructor(source: IImageAreaObject | ImageAreaObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._id = this.createIdPropertyEditor();
    this._name = this.createNamePropertyEditor();
    this._nameHistories = this.createNameHistoriesPropertyEditor();
    this._bookmark = this.createBookmarkPropertyEditor();
    this._printBehavior = this.createPropertyEditor(s => s.printBehavior, (s, v) => s.printBehavior = v);
    // 仕様では設定できるようになってるがv1は設定できないので無効化.TODO:QA確認後正式に対応する事.
    this._freeInputBehavior = this.createPropertyEditor(s => s.freeInputBehavior, (s, v) => s.freeInputBehavior = v, s => false);
    this._imageStyle = this.createPropertyEditor(s => s.imageStyle, (s, v) => s.imageStyle = v);
    this._scriptExecuteTriggerBehavior = this.createPropertyEditor(s => s.scriptExecuteTriggerBehavior, (s, v) => s.scriptExecuteTriggerBehavior = v);
  }

  protected _printBehavior: IPropertyEditable<IPrintBehavior>;
  protected _freeInputBehavior: IPropertyEditable<IFreeInputBehavior>;
  protected _imageStyle: IPropertyEditable<IImageStyle>;
  protected _scriptExecuteTriggerBehavior: IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;

  printBehavior(): IPropertyEditable<IPrintBehavior> {
    return this._printBehavior;
  }

  freeInputBehavior(): IPropertyEditable<IFreeInputBehavior> {
    return this._freeInputBehavior;
  }

  imageStyle(): IPropertyEditable<IImageStyle> {
    return this._imageStyle;
  }

  scriptExecuteTriggerBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>> {
    return this._scriptExecuteTriggerBehavior;
  }

  getTypeName(): string {
    return "画像エリア";
  }

  clone(): IFormatObjectEditable {
    return new ImageAreaObjectEditor(this);
  }
}
